import React, {useState} from "react";
import InformationCircleIcon from "../../components/Icons/InformationCircleIcon";
import { ChevronDown as IconDown } from "flowbite-react-icons/outline";
import HealthBadge from "../../components/Badges/HealthBadge";
import TwoBars from "../../components/Bars/TwoBars";
import {AiInsights, FeedbackType, SurveyFocusArea, SurveyResultInterface} from "./interfaces";
import ResultInfoModal from "./ResultInfoModal";
import SurveyQuestionsResult from "./components/SurveyQuestionsResult";
import {translateSection} from "./translations_name";

interface Props {
  surveyResult: SurveyResultInterface;
  aiInsights: AiInsights;
  lang: string;
  t: Function;
  feedbackType: FeedbackType;
  sorting: string;
  clientName: string;
}

const SurveyResultArea = ({surveyResult, lang, sorting, aiInsights, t, clientName, feedbackType} : Props) => {


  const [sortOrder, setSortOrder] = useState(sorting);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const sortOptions = [
    {key: "health_high", name: lang === "sv" ? "Status område": "Area Health"},
    {key: "scoreOther_high", name: lang === "sv" ? "Feedback": "Feedback"},
    {key: "scoreSelf_high", name: lang === "sv" ? "Självskattning": "Self-assessment"},
    {key: "gap_high", name: lang === "sv" ? "Gap": "Perception gap"},
  ];

  const findAiFocusArea = (focusAreaId: string) => {
    if (!aiInsights.focusAreas) return;
    for (const fa of aiInsights.focusAreas) {
      if (fa.id === focusAreaId) {
        return fa;
      }
    }
  }

  const renderFocusArea = (focusArea: SurveyFocusArea) => {
    const [open, setOpen] = useState(false);
    const aiFocusArea = findAiFocusArea(focusArea.id);

    return (
      <div className="bg-indigo-900 rounded-[6px] p-4 mt-6"
           key={"focus_area_" + focusArea.id}>
        <div className="cursor-pointer" onClick={() => setOpen(!open)}>
          <div className="flex flex-wrap items-start">
            <div className="flex-1 min-w-0">{translateSection(lang, focusArea)}</div>
            <div className="flex items-center ml-2 shrink-0">
              <HealthBadge value={focusArea.health} level={focusArea.healthLevel} lang={lang}/>
                <IconDown aria-hidden="true"
                    className={`ml-4 p-1cursor-pointer hover:bg-indigo-700 rounded-[20px] text-white! ${open ? "rotate-180" : ""}`}
                    />
            </div>
          </div>

          <div className="main-half-col small mt-2">
            <TwoBars value1={focusArea.scoreSelf} value2={focusArea.scoreOther}
                     max={surveyResult.nrAnswerOptions}
                     results1={focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions}
                     results2={focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions}
            />
          </div>
        </div>

        {
          open &&
            <SurveyQuestionsResult questions={focusArea.questions} surveyResult={surveyResult} lang={lang}
                                   aiFocusArea={aiFocusArea} clientName={clientName} feedbackType={feedbackType}/>
        }


      </div>
    )
  }

  const sortFunction = (a: SurveyFocusArea, b: SurveyFocusArea) => {
    const parts = sortOrder.split('_');
    let _sortOrder = "scoreOther";
    let direction = "high";
    if (parts.length === 2) {
      _sortOrder = parts[0];
      direction = parts[1];
    }
    let x = a.scoreOther;
    let y = b.scoreOther;

    if (_sortOrder === "scoreOther") {
      x = a.scoreOther;
      y = b.scoreOther;
    } else if (_sortOrder === "scoreSelf") {
      x = a.scoreSelf;
      y = b.scoreSelf;
    } else if (_sortOrder === "gap") {
      x = a.gap;
      y = b.gap;
    } else if (_sortOrder === "health") {
      x = a.health;
      y = b.health;
    }

    if (direction === "high") {
      return x < y ? 1 : -1;
    } else {
      return x > y ? 1 : -1;
    }

  }


  return (
    <>

      <div className="flex flex-wrap items-center mt-6 justify-between gap-y-2">
        <div className="flex items-center">
          <div className="z-heading1">
            {lang === "sv" ? "Resultat per område" : "Result per area"}
          </div>
          <div className="ml-2 flex item-center justify-center cursor-pointer rounded-[20px] p-1 hover:bg-indigo-700" onClick={() => setShowInfoModal(!showInfoModal)}> 
           <InformationCircleIcon alt="info" className="h-6 w-6"/></div>
        </div>

        {
          feedbackType !== FeedbackType.ONLY_SELF &&
            <div className="flex items-center">
              <p>{lang === "sv" ? "Sortera efter" : "Sort by"}</p>
              <div className="ml-2">
                <select className="z-select small" value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}>
                  {
                    sortOptions.map((option, i) => (
                      <option key={"sort_" + i} value={option.key}>{option.name}</option>
                    ))
                  }
                </select>
              </div>
            </div>
        }
      </div>

      {
        surveyResult.focusAreas.sort((a, b) => sortFunction(a, b)).map(focusArea => {
          return renderFocusArea(focusArea);
        })
      }

      <div className="mt-4">&nbsp;</div>
      {
        showInfoModal &&
          <ResultInfoModal close={() => setShowInfoModal(false)}/>
      }
    </>
  );
}

export default SurveyResultArea;